import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { getItemsTotals } from 'routes/probate-estate/fact-find/get-totals'
import { ProbateEstateItem } from 'lib/models/probate-estate'
import { BANK_ACCOUNT_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import OwnershipFields from './ownership-fields'
import RecordsSection, { RecordsSubSectionProps } from './records-section'

const BankAccounts = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => {
  const { total, sole, joint } = getItemsTotals(
    collection.items as ProbateEstateItem[]
  )

  return (
    <RecordsSection
      heading="2.3 Bank and building society accounts"
      cardType="Bank account"
      addLabel="Add bank account"
      toggleName="bankAccountsSectionActive"
      sectionActive={sectionActive}
      saveProbateEstateField={saveProbateEstateField}
      collection={collection}
      schema={BANK_ACCOUNT_SCHEMA}
      totals={{ total, sole, joint }}
      renderFields={({ handleSave }) => (
        <>
          <Grid.Item span={12}>
            <InputFloating
              name="providerName"
              label="Bank/building society name"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={12}>
            <InputFloating
              name="accountNumber"
              label="Account number"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={12}>
            <InputFloating
              name="sortCode"
              label="Sort code"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={12}>
            <InputFloating
              name="value"
              label="Value (£)"
              isCurrency
              handleSave={handleSave}
            />
          </Grid.Item>
          <OwnershipFields handleSave={handleSave} />
        </>
      )}
    />
  )
}

export default BankAccounts
